import type { Ref } from 'react';
import { breakpoints, Heading, Inline, LinkButton } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { string } from '@eti/utils';

const inlineStyles = css`
  justify-content: space-between;
`;

const removeTripButtonStyle = css`
  font-size: 0.875rem;

  @media (min-width: ${breakpoints._768}) {
    display: none;
  }
`;

interface BoundHeaderProps {
  boundIndex: number;
  headingRef?: Ref<HTMLHeadingElement>;
  onRemove: (boundId?: number) => void;
}

const BoundHeader = ({ boundIndex, headingRef, onRemove }: BoundHeaderProps) => {
  const { t } = useTranslation();

  const handleClick = () => onRemove(boundIndex);

  const isRemovableTrip = (i: number) => i > 1;

  return (
    <Inline className={inlineStyles}>
      <Heading data-testid="bound-header" level={3} ref={headingRef} tabIndex={-1}>
        {string.insertArgument(t('Air.Search.MultiBound.BoundHeader.Text'), boundIndex + 1)}
      </Heading>
      {isRemovableTrip(boundIndex) && (
        <LinkButton
          className={removeTripButtonStyle}
          data-testid={`searchForm-removeTrip-${boundIndex}-button`}
          onClick={handleClick}
        >
          {t('Searchform.RemoveBound.Button.Text')}
        </LinkButton>
      )}
    </Inline>
  );
};

export default BoundHeader;
